import { FEATURE_FLAGS_VALUE, TFeatureFlagName } from './constants';

export const getFeatureFlag = (featureFlag: TFeatureFlagName) => FEATURE_FLAGS_VALUE[featureFlag] || false;
